import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ObstacleCardProps {
  obstacle: string;
  solution: string;
  iconName: string;
}

export default function ObstacleCard({
  obstacle,
  solution,
  iconName,
}: ObstacleCardProps) {
  return (
    <div className="bg-card rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-border shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-105">
      <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-accent/10 flex items-center justify-center mb-5 sm:mb-6">
        <Icon name={iconName as any} size={24} className="text-accent sm:w-7 sm:h-7" />
      </div>
      <div className="space-y-3 sm:space-y-4">
        <div>
          <span className="text-xs font-mono uppercase text-muted-foreground tracking-wider">
            Obstacle
          </span>
          <p className="text-base sm:text-lg font-medium text-foreground mt-1">{obstacle}</p>
        </div>
        <div className="h-px w-12 bg-primary" />
        <div>
          <span className="text-xs font-mono uppercase text-success tracking-wider">
            Solution
          </span>
          <p className="text-base sm:text-lg font-medium text-success mt-1">{solution}</p>
        </div>
      </div>
    </div>
  );
}